function panoramaGridView(id,props) {
	this.ident = id;
	this.properties = props;
	
	swipe = new swiper();

	this.pano = new css3DNode("");	
		
	this.a = new css3DNode("#_a");
	this.a.translate(0,0,-375);
	this.pano.addChild(this.a);
	
	this.b = new css3DNode("#_b");
	this.b.translate(375,0,0);
	this.b.rotateY(-90);
	this.pano.addChild(this.b);

	this.c = new css3DNode("#_c");
	this.c.translate(0,0,375);
	this.c.rotateY(-180);
	this.pano.addChild(this.c);

	this.d = new css3DNode("#_d");
	this.d.translate(-375,0,0);
	this.d.rotateY(-270);
	this.pano.addChild(this.d);

	this.e = new css3DNode("#_e");
	this.e.translate(0,-375,0);
	this.e.rotateX(-90);
	this.pano.addChild(this.e);

	this.f = new css3DNode("#_f");
	this.f.translate(-1,372,0);
	this.f.rotateX(90);
	this.pano.addChild(this.f);
}

panoramaGridView.prototype = {
	rx: 0,
	ry: 0,
	inX: 0,
	inY: 0,
	panning:false,
	swipe:{},
	veryHighQualityLoaded:false,
	zoom:500,

	load: function() {		
		this.loadQuality(764);
	},
	
	loadQuality: function(q) {
		var ia = new Image();
		ia.onload = function() {
			$("#ia").attr('src',ia.src);
			};
		ia.src = player.storage + "/res.php?q=" + q + "&id=" + this.ident + "&part=1";
		
		var ib = new Image();
		ib.onload = function() {
			$("#ib").attr('src',ib.src);
			}
		ib.src = player.storage + "/res.php?q=" + q + "&id=" + this.ident + "&part=2";
		
		var ic = new Image();
		ic.onload = function() {
			$("#ic").attr('src',ic.src);
			}
		ic.src = player.storage + "/res.php?q=" + q + "&id=" + this.ident + "&part=3";
		
		var id = new Image();
		id.onload = function() {
			$("#id").attr('src',id.src);
			}
		id.src = player.storage + "/res.php?q=" + q + "&id=" + this.ident + "&part=4";
			
		var ie = new Image();
		ie.onload = function() {
			$("#ie").attr('src',ie.src);
			}
		ie.src = player.storage + "/res.php?q=" + q + "&id=" + this.ident + "&part=5";
			
		var iif = new Image();
		iif.onload = function() {
			$("#if").attr('src',iif.src);
			}
		iif.src = player.storage + "/res.php?q=" + q + "&id=" + this.ident + "&part=6";
	},
	
	process: function() {
		var tx = player._width * 0.5 - 375;
		var ty = player._height * 0.5 - 375;
					
		this.pano.resetTransform();
		this.pano.translate(tx, ty, this.zoom);
		this.pano.rotateX(this.ry);
		this.pano.rotateY(this.rx);
		this.pano.applyTransforms();
								
		this.zoom += swipe.distance();
		
		if (this.zoom < 550) this.zoom = 550;
		if (this.zoom > 750) this.zoom = 750;
		
		if (this.zoom > 650 && this.veryHighQualityLoaded == false) {
			this.loadQuality(1280);
			this.veryHighQualityLoaded = true;
		}
		
		this.rx += swipe.inertiaX() + 0.02;
		this.ry += swipe.inertiaY();
		
		//$("#info").html(this.ry + ", " + this.properties.params.bendup + ", " + this.properties.params.benddown);
		
		if (this.properties.params == false) {			
			this.ry = 0;
		} else if (this.properties.params.bend_type == "b") {
			if (this.ry < -this.properties.params.benddown) this.ry = -(this.properties.params.benddown * 1); 
			if (this.ry > this.properties.params.bendup) this.ry = (this.properties.params.bendup * 1); 
		} 
		
		if (this.ry > 75) this.ry = 75; 
		if (this.ry < -75) this.ry = -75; 
		
		this.inX *= 0.7;
		this.inY *= 0.7;
		
		if (this.panning) {
			this.calculateInertia(player._mouseX, player._mouseY);
		}
	},	
	
	calculateInertia: function(px,py) {
		this.inX = (px - player._width * 0.5) * 0.01;
		if (this.inX > 5) this.inX = 5;
		if (this.inX < -5) this.inX = -5;
		
		this.inY = (player._height * 0.5 - py) * 0.01;
		if (this.inY > 5) player.inY = 5;
		if (this.inY < -5) player.inY = -5;
	},
	
	mouseDown: function(event) {
		this.panning = true;
		swipe.start(event.originalEvent.touches);
		player.calculateInertia(player._mouseX, player._mouseY);
	},
	
	mouseUp: function(event) {
		swipe.end();
		this.panning = false;
	},
	
	mouseMove: function(event) {
		swipe.move(event.originalEvent.touches);
	}
}